<template>
  <v-container fluid class="pa-2 pa-sm-4 fill-height align-start">
    <v-row justify="center" class="mb-4 mt-4 w-100 max-w-custom mx-auto">
      
      <v-col cols="4">
        <v-card
          class="report-card rounded-xl d-flex flex-column align-center text-center transition-swing custom-card-height"
          hover
          @click="navegarParaResumo('ResumoVendasCidade')">
          <v-card-text class="d-flex flex-column justify-center align-center ma-3 pa-2 pa-sm-4 w-100 h-100">
            <v-icon size="32" color="blue" class="mb-1 mb-sm-3">mdi-city</v-icon>
            <span class="text-caption text-sm-body-2 font-weight-regular lh-tight color-dark">Vendas por Cidade</span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card
          class="report-card rounded-xl d-flex flex-column align-center text-center transition-swing custom-card-height"
          hover
          @click="navegarParaResumo('ResumoVendasGrupo')">
          <v-card-text class="d-flex flex-column justify-center align-center ma-3 pa-2 pa-sm-4 w-100 h-100">
            <v-icon size="32" color="teal" class="mb-1 mb-sm-3">mdi-google-circles-group</v-icon>
            <span class="text-caption text-sm-body-2 font-weight-regular lh-tight color-dark">Vendas por Grupo</span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card
          class="report-card rounded-xl d-flex flex-column align-center text-center transition-swing custom-card-height"
          hover
          @click="navegarParaResumo('ResumoVendasCliente')">
          <v-card-text class="d-flex flex-column justify-center align-center ma-3 pa-2 pa-sm-4 w-100 h-100">
            <v-icon size="32" color="deep-purple" class="mb-1 mb-sm-3">mdi-account-group</v-icon>
            <span class="text-caption text-sm-body-2 font-weight-regular lh-tight color-dark">Vendas por Cliente</span>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ViewDiversos',
  methods: {
    navegarParaResumo(nomeRelatorio) {
      this.$router.push({
        path: '/diversos_resumo',
        query: { relatorio: nomeRelatorio },
      });
    },
  },
};
</script>

<style scoped>
.bg-light { background-color: #f8fafc; }

.color-dark { color: #1e293b; }
.color-muted { color: #64748b; }

.max-w-custom {
  max-width: 1200px;
}

.report-card {
  cursor: pointer;
  border: 1px solid rgba(0,0,0,0.03) !important;
  background-color: #ffffff;
}

.report-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px -8px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(0,0,0,0.08) !important;
}

.custom-card-height {
  height: 110px;
}

.lh-tight {
  line-height: 1.2 !important;
}
</style>  